import { decodeHtmlEntities } from '@opallabs/lambda'
import { TextEditorAsset } from '../types'

type AssetReference = {
  asset_uuid?: string | null
  asset_type?: string | null
  filename?: string | null
  filesize?: number | null
  format?: string | null
  full_url?: string | null
  preview_url?: string | null
  width?: number | null
  height?: number | null
}

const parseAssetUuidFromUrl = (url: string): string | null =>
  /api\/v1\/asset_proxy\/([a-f0-9-]*)$/i.exec(url)?.[1] ?? null

/**
 * Transforms an asset reference from the API into the TextEditorAsset format.
 * Handles HTML entity decoding for filenames and UUID parsing from URLs.
 */
export const transformAssetReferenceToTextEditorAsset = (
  assetRef: AssetReference
): TextEditorAsset => ({
  assetUuid:
    assetRef.asset_uuid ??
    (assetRef.full_url ? parseAssetUuidFromUrl(assetRef.full_url) : null),
  assetType: assetRef.asset_type ?? null,
  filename: decodeHtmlEntities(assetRef.filename ?? null),
  filesize: assetRef.filesize ?? null,
  format: assetRef.format ?? null,
  fullUrl: assetRef.full_url ?? null,
  previewUrl: assetRef.preview_url ?? null,
  width: assetRef.width ?? null,
  height: assetRef.height ?? null,
})
